<ngx-loading-bar [includeSpinner]="false" [color]="'#ff3c38'"></ngx-loading-bar>
@if (isUnderMaintenance) {
    <div class="d-flex flex-column vh-100 vw-100 p-5 justify-content-center align-items-center">
        @if (logoUrl) {
            <img src="{{logoUrl}}" class="mb-5" alt="Company Logo" height="60px"/>
        }
        <h1 class="fw-bold text-center">{{ maintenanceConfig?.['messageTitle'] }}</h1>
        <p class="text-muted fs-15 text-center">{{ maintenanceConfig?.['messageContent'] }}</p>
        <img src="/assets/images/maintenance.png" alt="Under Maintenance" class="maintenance-image" />
      </div>
} @else  {
    @if (isPageQueryChecked) {
        <div class="full-width-container">
            <app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
            @for (section of headerAreaSections; track $index) {
                <app-sb-section [section]="section" [index]="$index" />
            }
            <router-outlet />
        
            @if (pageSettings?.pageLayoutType && pageSettings?.pageLayoutType !== "listing-page") {
                @for (section of footerAreaSections; track $index) {
                    <app-sb-section [section]="section" [index]="$index" />
                }
            }
            @if (globalService.blogPreview | async) {
                <app-preview-banner />
            }
            @if (isBrowser) {
                <app-network-banner [isOnline]="status === 'ONLINE'"></app-network-banner>
            }
        </div>
    }
}
  
